<template>
    <v-btn-toggle
        v-if="supplierCommitmentTabOptions.length > 1"
        v-model="selectedTab"
        mandatory="force"
        density="comfortable"
    >
        <v-btn
            v-for="tabOption in supplierCommitmentTabOptions"
            :key="tabOption"
            :value="tabOption"
            secondary
        >
            {{ toSentenceCase($t(`supplierCommitments.toggles.${tabOption}`)) }}
        </v-btn>
    </v-btn-toggle>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { unref } from 'vue';
import { includes } from 'lodash';
import featureFlags from '@enums/feature-flags';

const { supplierCommitmentOptions } = unref(featureFlags);

export default {
    props: {
        selectedSupplierCommitmentType: {
            type: String,
        },
    },

    computed: {
        ...mapState('clientConfig', ['toggleLogic']),
        ...mapState('supplierCommitments', ['activeSupplierCommitmentsSection']),

        supplierCommitmentTabOptions() {
            return this.toggleLogic[supplierCommitmentOptions];
        },

        selectedTab: {
            get() {
                return this.activeSupplierCommitmentsSection;
            },
            set(value) {
                this.setActiveSupplierCommitmentsSection({
                    activeSupplierCommitmentsSection: value,
                });
                this.emitter.emit('supplier-commitment-tab-changed');
            },
        },
    },

    mounted() {
        const selectedSupplierCommitmentType =
            this.selectedSupplierCommitmentType &&
            includes(this.supplierCommitmentTabOptions, this.selectedSupplierCommitmentType)
                ? this.selectedSupplierCommitmentType
                : this.supplierCommitmentTabOptions[0];
        this.onSupplierCommitmentTypeChange(selectedSupplierCommitmentType);
    },

    methods: {
        ...mapActions('supplierCommitments', ['setActiveSupplierCommitmentsSection']),

        onSupplierCommitmentTypeChange(value) {
            this.setActiveSupplierCommitmentsSection({ activeSupplierCommitmentsSection: value });
            this.emitter.emit('supplier-commitment-tab-changed');
        },
    },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
@import '@style/base/_mixins.scss';
:deep(.v-btn__overlay) {
    background-color: #000 !important;
}

:deep(.v-btn__content) {
    color: red;
}
</style>
